import moment from 'moment';

export const parseTimestamp = (timestamp) => {
  try {
    const timestampInMs = timestamp * 1000;
    return moment(timestampInMs).local().format('MMM D, YYYY, h:mma');
  } catch (error) {
    console.error('Error parsing timestamp:', error);
    return 'Invalid timestamp';
  }
};

export const convertCentsToDollars = (cents) => {
  try {
    if (typeof cents !== 'number' || Number.isNaN(cents)) {
      console.error('Invalid cents:', cents);
      return '0';
    }
    const dollars = (cents / 100).toFixed(2);
    return dollars;
  } catch (error) {
    console.error('Error converting cents to dollars:', error);
    return '0';
  }
};
